import { render, staticRenderFns } from "./DiningArea.vue?vue&type=template&id=6ed8d519&scoped=true&"
import script from "./DiningArea.vue?vue&type=script&lang=js&"
export * from "./DiningArea.vue?vue&type=script&lang=js&"
import style0 from "./DiningArea.vue?vue&type=style&index=0&id=6ed8d519&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed8d519",
  null
  
)

export default component.exports